// actions/connect/save.js

import { attachAuth } from '../../utils/authService';
import PubSub         from 'pubsub-js';

// --- ALL ---

export function connectSourcesSaveHasErrored(bool) {
  return {
    type: 'CONNECT_SOURCES_SAVE_HAS_ERRORED',
    hasErrored: bool
  };
}

export function connectSourcesSaveIsLoading(bool) {
  return {
    type: 'CONNECT_SOURCES_SAVE_IS_LOADING',
    isLoading: bool
  };
}

export function connectSourcesSaveFetchDataSuccess(obj) {
  return {
    type: 'CONNECT_SOURCES_SAVE_FETCH_DATA_SUCCESS',
    obj
  };
}

export function connectSourcesSaveFetchData(host, body) {
  return (dispatch) => {
    dispatch(connectSourcesSaveIsLoading(true));
    dispatch(connectSourcesSaveHasErrored(false));
    fetch(host + 'connect/sources/save', {
      method: 'post',
      body: JSON.stringify(body),
      headers: attachAuth()
    }).then(promise => {
        if (!promise.ok) {
          throw Error(promise.statusText);
        }
        
        promise.json()
          .then(result => {
            dispatch(connectSourcesSaveFetchDataSuccess(result));
            dispatch(connectSourcesSaveHasErrored(false));
            dispatch(connectSourcesSaveIsLoading(false));
            PubSub.publish('connect.sources.save', result);
          })
          .catch((ex) => {
            console.log(ex);
            dispatch(connectSourcesSaveHasErrored(true));
            dispatch(connectSourcesSaveIsLoading(false));
          });
    })
    .catch((ex) => {
      console.log(ex);
      dispatch(connectSourcesSaveHasErrored(true));
      dispatch(connectSourcesSaveIsLoading(false));
    });
  };
}